/**
 * Authors: mariushirjanu
 * Created: 05/08/2021
 */
import { Component, Input, OnInit } from '@angular/core';
import { FormattingService } from '../../services/formatting.service';
import { IInvoiceTemplate, InvoiceTemplatesDataService } from './invoice-templates-data.service';
import { StateService } from '@uirouter/angular';
import { InvoiceTemplatesService } from './invoice-templates.service';

@Component({
  selector: 'invoice-templates',
  template: `
    <div class="form-horizontal">
      <div class="table-and-buttons">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th class="edit-column"></th>
              <th translate>INVOICE.INVOICE_TEMPLATES.GRID.INVOICE_DIRECTION</th>
              <th translate>GA.GENERAL.TYPE</th>
              <th translate>INVOICE.INVOICE_TEMPLATES.GRID.MY_COMPANY</th>
              <th translate>INVOICE.INVOICE_TEMPLATES.GRID.ACSL_COMPANY</th>
              <th translate>INVOICE.INVOICE_TEMPLATES.GRID.MINIMUM_AMOUNT</th>
              <th translate>INVOICE.INVOICE_TEMPLATES.GRID.PAYMENT_TERMS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let invoice of invoices; trackById">
              <td class="edit-column">
                <div class="btn-group" dropdown>
                  <button class="btn btn-sm dropdown-arrow-btn dropdown-toggle" dropdownToggle>
                  </button>
                  <ul class="dropdown-menu" *dropdownMenu>
                    <li><a href [uiSref]="detailState" [uiParams]="{ invoiceTemplateId: invoice.id }"><i class="fa fa-eye"></i><span class="menu-item-text" translate>INVOICE.INVOICE_TEMPLATES.OPTIONS.SHOW_DETAIL</span></a></li>
                    <li *ngIf="writeSupport" (click)="editDetails($event, invoice.id)"><a href><i class="fa fa-pencil"></i><span class="menu-item-text" translate>GA.BUTTONS.EDIT</span></a></li>
                  </ul>
                </div>
              </td>
              <td><a href [uiSref]="detailState" [uiParams]="{ invoiceTemplateId: invoice.id }">{{invoice.direction}}</a></td>
              <td><a href [uiSref]="detailState" [uiParams]="{ invoiceTemplateId: invoice.id }">{{invoice.type}}</a></td>
              <td>{{formatCompanyCountryL(invoice.companyCountry)}}</td>
              <td>{{formatCompanyCountryL(invoice.acslCompanyCountry)}}</td>
              <td class="text-end nowrap">{{formatAmount(invoice.minimumAmount, invoice.currency)}}</td>
              <td class="nowrap">{{formatDays(invoice.paymentTerms)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `
})
export class InvoiceTemplatesComponent implements OnInit {
  @Input() public companyCountryId:number;
  @Input() public detailState:string;
  @Input() public writeSupport:boolean;

  public invoices:IInvoiceTemplate[];
  public formatCompanyCountryL:Function = this.formattingService.formatCompanyCountryL;
  public formatAmount:Function = this.formattingService.formatAmount;
  public formatDays:Function = this.formattingService.formatDays;

  constructor(
    private formattingService:FormattingService,
    private invoiceTemplatesDataService:InvoiceTemplatesDataService,
    private stateService:StateService,
    private invoiceTemplatesService:InvoiceTemplatesService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.invoiceTemplatesDataService.invoiceTemplates(this.companyCountryId)
      .then((data:IInvoiceTemplate[]) => {
        this.invoices = data;
      });
  }

  public editDetails(e:Event, id:number):void {
    e.preventDefault();

    this.invoiceTemplatesService.editing = true;
    this.stateService.go(this.detailState, { invoiceTemplateId: id });
  }
}